import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route,Link } from 'react-router-dom';
import './App.css';
import { getUserRole } from './utils/common';
//Admin Pages
import Nav from './Nav';
import AdminDashboard from './components/AdminDashboard';
import AdmMaster from './components/AdminMaster';
import AdminDevices from './components/DeviceList';
import DeviceSetup from './components/DeviceSetup';
import CustomerList from './components/CustomerList';
import DeviceSale from './components/DeviceSale'
import SubscriptionRenewal from './components/SubscriptionRenewal'
import SubscriptionList from './components/SubscriptionList';
import CheckDashboard from './components/ClientApplication/CheckDashboard';
import AdminVehicle from './components/AdminVehicleList';
import AdminVehicleHistory from './components/VehicleHistory';
import UserList from './components/UserList';

//Commponent Pages
import CDashboard from './components/ClientApplication/CDashboard';
import CDriverList from './components/ClientApplication/CDriverList';
import CDeviceList from './components/ClientApplication/CDeviceList';
import VehiclesMonitor from './components/ClientApplication/VehiclesMonitor';
import CLVehicleList from './components/ClientApplication/CLVehicleList';
import CViewLive from './components/ClientApplication/CViewLive';
import DashboardMap from './components/ClientApplication/DashboardMap';
import SubUserList from './components/ClientApplication/SubUserList';
import ExpiryDeviceList from './components/ExpiryDeviceList';
//Alert
import Alert from './components/ClientApplication/Alert';
import AlertSettings from './components/ClientApplication/AlertSettings';
//History
import CDHISTORY from './components/ClientApplication/VHistory';
//UserMannual
import UserHelp from './components/ClientApplication/UserHelp';
//Google Poligone
import MapPoligone from './components/MapPoligone';
//Report Page
import ClReports from './components/ClientApplication/CReport';
import ClDistanceReport from './components/ClientApplication/ClientReports/DistanceReport';
import ClOverSpeedingReport from './components/ClientApplication/ClientReports/OverSpeedingReport';
import ClStoppageReport from './components/ClientApplication/ClientReports/StoppageReport';
import ClHistoryReport from './components/ClientApplication/ClientReports/HistoryReport';
//Geofence
import GeoFenceAlert from './components/ClientApplication/GeoFenceAlert';
import AdminCommands from './components/AdminCommands';
//Start Payment GT-248
import PaymentRecieved from './components/PaymentRecieve';
import CreditNotes from './components/CreditNote';
import DebitNotes from './components/DebitNote';
import OutStandingReports from './components/OutStandingReport';
import LedgerReport from './components/LedgerReports';
import PaymentRecieveReport from './components/PaymentRecieveReport.js';
//Fuel sensor
import FuelDetails from './components/ClientApplication/FuelDetails';
import FuelRefill from './components/ClientApplication/FuelRefill';
import FuelTheft from './components/ClientApplication/FuelTheft';
import FuelConsumed from './components/ClientApplication/FuelConsumed';

//end of Payment ledger report GT-248
const Home = () => {
  return (
  
      <main>
        <div className="row">
          <div className="top-bar clearfix">
            <div className="row">
              <div className="col-xs-12">
                <h4> About Us</h4>
              </div>
            </div>
          </div>
        </div>
      </main>
   
  );
};
const Apprt = () => {
  return (
   
    <main>
      <div className="row">
        <div className="top-bar clearfix">
          <div className="row">
            <div className="col-xs-12">
              <h4>  Registration Details</h4>
            </div>
          </div>
        </div>
      </div>
      <ClientDashboard/>
  </main>
); }
const MAlert=()=>{
  return (
  <main>
      <Alert/>
</main>
  
  ); }


  const MAlertSettings=()=>{
    return (
    <main>
        <AlertSettings/>
  </main>
   
    ); }
const Price=()=>{
  return (<Price/>);
}
const ADashboard=()=>{
  return (<AdminDashboard/>);
}
const ClientDashboard=()=>
{
  return(<CDashboard/>);
}
const AMaster=()=>{
  return (<AdmMaster/>);
}
const DSetup=()=>{
   return (
   
      <main>
     <div className="row">
       <div className="top-bar clearfix">
         <div className="row">
           <div className="col-xs-12">
             <h4> Add Device </h4>
           </div>
         </div>
       </div>
     </div>
     <DeviceSetup/>
 </main>
 
   );
}
const DList=()=>{
  return (
   
    <main>
    <AdminDevices/>
    </main>
 
  );
}
const Clist=()=>{
  return (
  <main>
      <CustomerList/>
</main>
 
  );
}
const CDList=()=>{
  return (
    
    <main>
    <CDriverList/>
    </main>
 
  );
}

const SUserList=()=>{
  return (
    
    <main>
    <SubUserList/>
    </main>
 
  );
}
const Devices=()=>{
  return (
   
    <main>
    <CDeviceList/>
    </main>
 
  );
}

const CLVehiclesList=()=>{
  return (
    
    <main>
    <CLVehicleList/>
    </main>
 
  );
}
const DevSale=()=>{
  return (
    
    <main>
    <DeviceSale/>
    </main>
  
  );
}
const Subscription_List=()=>{
  return (
    
    <main>
    <SubscriptionList/>
    </main>
  
  );
}

const DevRenewal=()=>{
  return (
   
    <main>
    <SubscriptionRenewal/>
    </main>
 
  );
}

const VMonitor=()=>{
  return (
   
    <main>
    <VehiclesMonitor/>
    </main>
 
  );
}
const VHistory=()=>{
  return (
   
    <main>
    <CDHISTORY/>
    </main>
  
  );
}
const UsrHelp=()=>{
  return (
   
    <main>
    <UserHelp/>
    </main>
 
  );
}
const UserPoligone=()=>{
  return (   
    <main>
    <MapPoligone/>
    </main>
 
  );
}
const CView_Live=()=>{
  return (
   
    <main>
    <CViewLive/>
    </main>
 
  );
}

const Dashboard_Map=()=>{
  return (
   
    <main>
    <DashboardMap/>
    </main>
 
  );
  
}
const CReports=()=>{
  return (
   
    <main>
    <ClReports/>
    </main>
  
  );
}
const CDistanceReport=()=>{
  return (
     
    <main>
    <ClDistanceReport/>
    </main>
  
  );
  }
  const COverSpeedingReport=()=>{
    return (       
      <main>
      <ClOverSpeedingReport/>
      </main>    
    );
    }
  const CStoppageReport=()=>{
      return (
         <main>
        <ClStoppageReport/>
        </main>      
      );
      }
  const CHistoryReport=()=>{
    return (
      <main>
     <ClHistoryReport/>
     </main>      
    );
    }
    const AdminVHistory=()=>
      {
        return (
          <main>
          <AdminVehicleHistory/>
          </main>
        );
      }
      const AdmVList=()=>
        {
          return (
            <main>
            <AdminVehicle/>
            </main>
          );
        }
        const AdminUserList=()=>
        {
             return (
            <main>
            <UserList/>
            </main>
          );

        }
        const GeoFence_Alert=()=>{
        return (
          <main>
            <GeoFenceAlert/>
          </main>
        );
        
}
const ExpDList=()=>{
      return (
        <main>
        <ExpiryDeviceList/>
        </main>
      );
}
const AdminCommand=()=>{
      return (
        <main>
        <AdminCommands/>
        </main>
      );
}
const PaymentRecieve=()=>{
return(
  <main>
    <PaymentRecieved/>
  </main>
)
}
const CreditNote=()=>{
   return(
  <main>
    <CreditNotes/>
  </main>
)
}
const DebitNote=()=>{
return(
  <main>
    <DebitNotes/>
  </main>
)  
} 
const LedgerReports=()=>{
return(
  <main>
    <LedgerReport/>
  </main>
)}
const OutStandingReport=()=>{
return(
  <main>
    <OutStandingReports/>
  </main>
)}   
const AdmPaymentRecieveReport=()=>{
return(
  <main>
    <PaymentRecieveReport/>
  </main>
)}
const CFuelDetails=()=>{
    return (
      <main>
     <FuelDetails/>
     </main>
    );
    }
const CFuelRefill=()=>{
    return (
      <main>
     <FuelRefill/>
     </main>
    );
    }
const CFuelTheft=()=>{
    return (
      <main>
     <FuelTheft/>
     </main>
    );
    }
const CFuelConsumed=()=>{
    return (
      <main>
     <FuelConsumed/>
     </main>
    );
    }
class App extends Component {
  render()
   {
      

    return (

      <> 
      
      <Router>
     <div className="page-panel" >
        <AdmMaster/>  
      <div className="page-body">
     
      <div className="sidebar">                    
           <Nav/>          
          </div>
       
              <>
                
                <Routes>
                <Route path="/" element={<CheckDashboard />}/>
                <Route index element={<CheckDashboard />} />
                <Route path="/AdminDashboard" element={<ADashboard/>} />
                <Route path="/AdminDevices" element={<DList/>} />
                <Route path="/DSetup" element={<DSetup/>} />
                <Route path="/Apprt" element={<Apprt/>} />
                <Route path="/AdminCustomers" element={<Clist/>} />
                <Route path="/ClientDashboard" element={<ClientDashboard/>} />
                <Route path="/Drivers" element={<CDList/>} />
                <Route path="/SUserList" element={<SUserList/>} />
                <Route path='/AdminUserList'  element={<AdminUserList/>} />
                
                <Route path="/Devices" element={<Devices/>} />
                <Route path="/VehicleMonitor" element={<VMonitor/>} />
                <Route path="/Vehicles" element={<CLVehiclesList/>} />
                <Route path="/Price" element={<Price/>} />
                <Route path="/Alert" element={<MAlert/>} />
                <Route path="/AlertSettings" element={<MAlertSettings/>} />
                <Route path="/SaleDevice" element={<DevSale/>} />
                <Route path="/DeviceRenewal" element={<DevRenewal/>} />
                <Route path="/History" element={<VHistory/>} />
                <Route path="/Subscription_List" element={<Subscription_List/>} />
                <Route path="/UserHelp" element={<UsrHelp/>} />
                <Route path="/UserPoligone" element={<UserPoligone/>} />
                <Route path="/CViewLive" element={<CView_Live/>} />                
                <Route path="/DashboardMap" element={<Dashboard_Map/>} />
                <Route path="/Reports" element={<CReports/>} />
                <Route path="/CDistanceReport" element={<CDistanceReport/>} />
                <Route path="/COverSpeedingReport" element={<COverSpeedingReport/>} />
                <Route path="/CStoppageReport" element={<CStoppageReport/>} />
                <Route path="/CHistoryReport" element={<CHistoryReport/>} />
                <Route path="/AdminVehicles" element={<AdmVList/>} />
                <Route path="/AdminVehHistory"   element={<AdminVHistory/>} />
                <Route path="/GeoFenceAlert" element={<GeoFence_Alert/>} />
                <Route path="/ExpiryDevices" element={<ExpDList/>} />
                <Route path="/AdminCommand" element={<AdminCommand/>} />
                <Route path="/PaymentRecieve" element={<PaymentRecieve/>} />
                <Route path="/CreditNote" element={<CreditNote/>} />
                <Route path="/DebitNote" element={<DebitNote/>}/>
                <Route path="/LedgerReports" element={<LedgerReports/>}/>
                <Route path="/OutStandingReport" element={<OutStandingReport/>}/>
                <Route path="/AdmPaymentRecieveReport" element={<AdmPaymentRecieveReport/>}/>
                <Route path="/CFuelDetails" element={<CFuelDetails/>} />
                <Route path="/CFuelRefill"  element={<CFuelRefill/>} />
                <Route path="/CFuelTheft" element={<CFuelTheft/>} />
                <Route path="/CFuelConsumed" element={<CFuelConsumed/>} />
                </Routes>
              </>
        
             
      
   </div>

    </div>
    </Router> 
    </>


       
    );
  }
}


//export default App;
//import logo from './logo.svg';
//import './App.css';
//function App() {
  //return (
    //<div className="App">
      //<header className="App-header">
       // Learn React from Manish Tripathi
     // </header>
    //</div>
  //);
//}
export default App;